import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-client';

/**
 * Hook to fetch dashboard statistics
 */
export function useDashboardStats() {
  return useQuery({
    queryKey: queryKeys.dashboardStats(),
    queryFn: () => api.getDashboardStats(),
    // Refetch every 30 seconds to keep stats fresh
    refetchInterval: 30000,
    // Don't refetch on window focus to avoid too many requests
    refetchOnWindowFocus: false,
  });
}
